<template>
  <div>
    <Header></Header>

    <LayerPopVideo
      :visible="layerVisible"
      @closeLayer="close()"
    ></LayerPopVideo>

    <section class="top-img ov-auto">
      <div class="mw-1200 pl-10px pr-10px">
        <h1 class="title mt-220px white fw-900 lh-45px">기업교육 만족도 1위</h1>
        <h2 class="sub-title mt-35px white fw-500">
          학습시스템에서부터 체계적인 관리까지,
        </h2>
        <h2 class="sub-title white fw-500">퀄리티로 증명하는 당근영어</h2>
        <h4 class="download proposal ft-20px mt-30px fw-500 pointer">
          제안서 다운로드 >
        </h4>

        <div class="m-btn-group">
          <div class="inquiry mt-80px">
            <span
              class="ft-20px white fb title pointer"
              @click="scrollId('inquiry')"
            >
              교육 문의하기
            </span>
          </div>
          <div class="introduce ml-20px">
            <span
              class="title ft-20px fb white pointer"
              @click="layerVisible = !layerVisible"
            >
              소개 영상 보기
            </span>
          </div>
        </div>
      </div>

      <div class="statistics pt-37px pb-36px">
        <ul class="clear mw-1200">
          <li class="float-left w-33per txt-left">
            <div class="m-statistics dp-inblock ver-top">
              <div class="circle-box">
                <div class="icon-parent">
                  <img
                    class="person-icon"
                    src="@/assets/img/people.png"
                    alt="고객사 수"
                  />
                </div>
              </div>
            </div>
            <div class="m-statistics text dp-inblock ml-25px white">
              <h2 class="white count-title fw-500">고객사 수</h2>
              <h3 class="white count fb mt-12px">5,000+</h3>
            </div>
          </li>

          <li class="float-left w-33per txt-center">
            <div class="m-statistics dp-inblock ver-top">
              <div class="circle-box">
                <div class="icon-parent">
                  <img
                    class="heart-icon"
                    src="@/assets/img/heart.png"
                    alt="오늘의 수업 만족도"
                  />
                </div>
              </div>
            </div>
            <div class="m-statistics text dp-inblock ml-25px white">
              <h2 class="white count-title fw-500 txt-left">
                오늘의 수업 만족도
              </h2>
              <h3 class="white count fb mt-12px txt-left">
                4.96/<span class="ft-20px">5.0점</span>
              </h3>
            </div>
          </li>

          <li class="float-left w-33per txt-right">
            <div class="m-statistics dp-inblock ver-top">
              <div class="circle-box">
                <div class="icon-parent">
                  <img
                    class="messages-icon"
                    src="@/assets/img/message.png"
                    alt="교육언어"
                  />
                </div>
              </div>
            </div>

            <div class="m-statistics text dp-inblock ml-25px white">
              <h2 class="white count-title fw-500 txt-left">교육 언어</h2>
              <h3 class="white count fb mt-12px">20개국↑</h3>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="first pt-125px pb-80px">
      <div class="mw-1200 m-first">
        <h1 class="first-title ft-45px lh-63px fb txt-center">
          모바일화상 업계 최초 도입, 에듀테크 선도기업!
        </h1>
        <h1 class="second-title ft-45px lh-63px fb txt-center">
          Workflow Learning 실현을 위한
          <span class="bright-pink">맞춤교육 시스템</span>
        </h1>
        <ul class="clear mt-70px enviroment-center">
          <li class="enviroment float-left w-55per">
            <h1 class="enviroment-title ft-37px lh-50px txt-left fb keep-all">
              업무 환경이 달라도 <br />
              당근영어는 LIVE
            </h1>
            <h3
              class="enviroment-desc ft-24px lh-34px mt-27px txt-left bright-gray"
            >
              해외 출장 중에도! 외국에서 근무하는 현채인도! <br />
              학습 지속성을 높인 기업 전용 수업 플랫폼 구축<br />
              (전화 ↔ 모바일 화상 ↔ PC화상)
            </h3>
          </li>
          <li class="enviroment2 float-right w-42per">
            <img
              class="enviroment2-img"
              src="@/assets/img/first-section-img.svg"
              alt="학습자속성"
              style="width: 100%"
            />
          </li>
        </ul>
      </div>
    </section>

    <section class="second pt-80px pb-80px">
      <div class="mw-1200 m-second">
        <ul class="clear reverse">
          <li class="contents-img reverse-child float-left w-48per lh-436px">
            <img
              class="contents-image"
              src="@/assets/img/contents.png"
              alt="콘텐츠"
            />
          </li>
          <li class="contents reverse-child float-right w-48per">
            <h1 class="contents-title ft-37px lh-49px txt-left fb">
              자체 개발 5,000여개 콘텐츠로
            </h1>
            <h1 class="contents-title ft-37px lh-49px txt-left fb">
              고객사 맞춤 과정 설계!
            </h1>

            <h3
              class="contents-desc mt-30px ft-24px lh-34px txt-left bright-gray"
            >
              저작권 걱정 없이! 온라인북, 교재 PDF, 동영상 등 <br />
              언어연구소에서 개발한 콘텐츠 무제한 제공
            </h3>
          </li>
        </ul>
      </div>
    </section>

    <section class="third pt-80px pb-80px">
      <div class="mw-1200 m-third">
        <ul class="clear">
          <li class="satisfaction float-left w-48per">
            <h1 class="satisfaction-title ft-37px lh-49px txt-left fb">
              실시간 만족도 4.96/<span class="ft-25px">5.0 만점</span>
            </h1>
            <h1 class="satisfaction-title ft-37px lh-49px txt-left fb">
              평균 수료율 98% 이상!
            </h1>

            <h3
              class="satisfaction-desc mt-30px ft-24px lh-34px txt-left bright-gray"
            >
              기업 전담팀, 고객관리 시스템을 통한<br />
              체계적인 과정 운영
            </h3>
          </li>
          <li class="satisfaction-image float-right w-44per">
            <img
              class="satisfaction-img"
              src="@/assets/img/class-satisfaction.png"
              alt="수업만족도"
              style="width: 100%"
            />
          </li>
        </ul>
      </div>
    </section>

    <section class="fourth pt-120px pb-100px">
      <div class="mw-1200 m-fourth">
        <h1 class="course-title ft-45px lh-63px fb txt-center">
          국내 임직원부터 해외 주재원, 현채인까지
        </h1>
        <h1 class="course-title2 ft-45px lh-63px fb txt-center">
          어디서든 맞춤 교육 지원
        </h1>

        <ul class="clear card-list mt-75px">
          <li class="card float-left pb-35px">
            <img class="card-img" src="@/assets/img/card1.png" alt="카드1" />
            <h2 class="mt-35px ml-25px text-left lh-42px ft-28px fb pointer">
              스피킹 레벨 UP코스
            </h2>

            <h3 class="ml-25px text-left ft-22px lh-30px keep-all w-60per">
              일상대화를 넘어 토론까지 가뿐하게!
            </h3>

            <div
              class="dp-inblock mt-40px ml-25px pointer"
              @click="
                newPage(
                  'https://www.carrotenglish.kr/phone/program_regular#book'
                )
              "
            >
              <div class="text dp-inblock">
                <h2 class="dp-inblock detail ft-20px txt-bright-gray">
                  과정 상세보기
                </h2>
                <img
                  class="arrow-img"
                  src="@/assets/img/arrow.png"
                  alt="화살표"
                />
              </div>
            </div>
          </li>

          <li class="card float-left pb-35px ml-36px">
            <img class="card-img" src="@/assets/img/card2.png" alt="카드2" />

            <h2 class="card-title mt-35px ml-25px text-left lh-42px ft-28px fb">
              Biz 실무마스터 코스
            </h2>

            <h3 class="card-desc ml-25px text-left ft-22px lh-30px">
              비즈니스에서 필요한 <br />
              스킬만 모아모아!
            </h3>

            <div
              class="dp-inblock mt-40px ml-25px pointer"
              @click="
                newPage(
                  'https://www.carrotenglish.kr/phone/program_business#book'
                )
              "
            >
              <div class="text dp-inblock">
                <h2 class="dp-inblock detail ft-20px txt-bright-gray">
                  과정 상세보기
                </h2>
                <img
                  class="arrow-img"
                  src="@/assets/img/arrow.png"
                  alt="화살표"
                />
              </div>
            </div>
          </li>

          <li class="card float-left pb-35px ml-36px">
            <img class="card-img" src="@/assets/img/card3.png" alt="카드3" />

            <h2 class="card-title mt-35px ml-25px text-left lh-42px ft-28px fb">
              On the job 코스
            </h2>

            <h3 class="card-desc ml-25px text-left ft-22px lh-30px">
              실무현장에서 요구되는 <br />
              커뮤니케이션을 원활하게!
            </h3>

            <div
              class="dp-inblock mt-40px ml-25px pointer"
              @click="
                newPage(
                  'https://www.carrotenglish.kr/phone/program_business_skill#book'
                )
              "
            >
              <div class="text dp-inblock">
                <h2 class="dp-inblock detail ft-20px txt-bright-gray">
                  과정 상세보기
                </h2>
                <img
                  class="arrow-img"
                  src="@/assets/img/arrow.png"
                  alt="화살표"
                />
              </div>
            </div>
          </li>
        </ul>

        <div class="process clear mt-40px">
          <h1 class="process-title ft-28px fb white">
            특별코스 및 맞춤 과정까지
          </h1>

          <ul class="clear mt-35px process-list">
            <li class="float-left list-box">
              <div class="circle white fw-500">Ted-Ed</div>
            </li>

            <li class="list float-left list-box">
              <div class="circle white fw-500">Trendy English</div>
            </li>

            <li class="list float-left list-box">
              <div class="circle white fw-500">Global Insight</div>
            </li>

            <li class="list float-left list-box">
              <div class="circle white fw-500">로이터 뉴스</div>
            </li>

            <li class="list float-left">
              <div class="circle white fw-500">공인시험 대비</div>
            </li>
          </ul>

          <h2 class="other txt-right mt-20px ft-22px fw-500 white">
            그 외 5,000개 과정제공
          </h2>

          <div
            class="text float-right dp-inblock pointer mt-40px"
            @click="newPage('https://www.carrotenglish.kr/phone/program_basic')"
          >
            <h2 class="dp-inblock ft-20px txt-bright-gray">과정 상세보기</h2>
            <img class="arrow-img" src="@/assets/img/arrow.png" alt="화살표" />
          </div>
        </div>
      </div>
    </section>

    <section class="five pt-120px pb-100px">
      <div class="mw-1200 m-five">
        <h1 class="performance-title ft-45px fb lh-63px txt-center">
          업계 최다 외국어 강사 POOL보유(20개국 언어)
        </h1>
        <h1 class="performance-title ft-45px fb lh-63px txt-center">
          +특수어 요청 시 오픈가능
        </h1>
        <div class="rank mt-70px pl-70px pr-60px">
          <ul class="clear">
            <li class="card float-left">
              <h1 class="txt-center">
                <span
                  class="circle blue pt-15px pr-25px pb-15px pl-25px ft-28px lh-42px fb"
                  >1</span
                >
              </h1>
              <h1 class="rank-title txt-center mt-30px ft-28px fb dark-gray">
                <span class="rank-title1 dp-block pink">국내 최다 언어</span>
                <span class="rank-title2 dp-block mt-10px fw-500 dark-blue">
                  강사진 보유</span
                >
              </h1>
            </li>
            <li class="card float-left">
              <h1 class="txt-center">
                <span
                  class="circle pink pt-15px pr-25px pb-15px pl-25px ft-28px lh-42px fb"
                  >2</span
                >
              </h1>
              <h1 class="rank-title txt-center mt-30px ft-28px fb dark-pink">
                <span class="rank-title1 pink dp-block bright-pink"
                  >전 언어</span
                >
                <span class="rank-title2 dp-block mt-10px fw-500 bright-pink">
                  전화, 화상수업 제공</span
                >
              </h1>
            </li>
            <li class="card float-left">
              <h1 class="txt-center">
                <span
                  class="circle blue pt-15px pr-25px pb-15px pl-25px ft-28px lh-42px fb"
                  >3</span
                >
              </h1>
              <h1 class="rank-title txt-center mt-30px ft-28px fb dark-gray">
                <span class="rank-title1 dp-block">국가별 이문화</span>
                <span class="rank-title2 dp-block fw-500 dark-blue mt-10px">
                  동영상 학습 지원</span
                >
              </h1>
            </li>
          </ul>
        </div>

        <div class="language mt-55px pt-50px pb-45px pl-72px pr-72px">
          <div class="languages-list">
            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/cn.png"
                    alt="중국어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">중국어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/jp.png"
                    alt="일본어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">일본어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/vi.png"
                    alt="베트남어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">베트남어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/th.png"
                    alt="태국어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">태국어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/mm.png"
                    alt="미얀마어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">미얀마어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/id.png"
                    alt="인도네시아어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">
                  인도네시아어
                </h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/es.png"
                    alt="스페인어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">스페인어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/pf.png"
                    alt="포르투칼어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">포르투칼어</h3>
              </div>
            </div>
          </div>

          <div class="languages-list mt-45px">
            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/fr.png"
                    alt="프랑스어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">프랑스어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/ru.png"
                    alt="러시아어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">러시아어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/de.png"
                    alt="독일어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">독일어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/it.png"
                    alt="이탈리아어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">이탈리아어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/cz.png"
                    alt="체코어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">체코어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/sa.png"
                    alt="아랍어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">아랍어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/in.png"
                    alt="힌디어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">힌디어</h3>
              </div>
            </div>

            <div class="item">
              <div class="txt-center">
                <span class="img-parent">
                  <img
                    class="country-images"
                    src="@/assets/img/languages/kh.png"
                    alt="캄보디아어"
                  />
                </span>
                <h3 class="country-name mt-15px ft-16px fw-600">캄보디아어</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="six pt-85px pb-75px">
      <div class="mw-1200 m-six">
        <h1 class="title txt-center ft-45px lh-1px fb white">기업교육 NO.1</h1>
        <h1 class="title2 txt-center ft-45px lh-70px fb white">
          5,000여개의 기업이 선택한 당근영어
        </h1>

        <h3 class="title3 txt-center ft-22px lh-1px fw-500 gray mt-35px">
          기업·공공·지자체
        </h3>
      </div>
    </section>

    <section class="seven pt-90px pb-90px">
      <div class="mw-1200 m-seven">
        <img class="country" src="@/assets/img/company.png" alt="기업" />
        <div class="parent-company-image">
          <img src="@/assets/img/m-company2.png" alt="" class="m-country" />
        </div>
      </div>
    </section>

    <section class="eight pt-85px pb-95px" id="inquiry">
      <div class="clear mw-1200 m-eight">
        <h2 class="title ft-45px white fb">문의하기</h2>

        <h3 class="sub-title ft-25px lh-35px deep-dark-gray mt-35px">
          B2B 교육 및 솔루션에 대한 문의를 남겨주시면 담당자가 확인 후
          <br class="line-break" />
          최대한 빠른 시간 내에 연락드리겠습니다.
        </h3>

        <h3 class="sub-title2 ft-22px deep-dark-gray mt-35px">
          (혹시 이미 교육을 받고 계신 학습자이신가요?
          <span
            class="sky-blue pointer"
            @click="newPage('http://carrotenglish.kr/phone/main_new/contact')"
            >Click!</span
          >)
        </h3>

        <ul class="clear mt-35px">
          <li class="input-info float-left w-53per">
            <form>
              <div class="clear input-box">
                <label class="form-input ft-22px white fw-500 txt-left"
                  >회사명</label
                >
                <input
                  class="input"
                  type="text"
                  v-model="inquiryData.company"
                />
              </div>
              <div class="clear mt-15px input-box">
                <label class="form-input ft-22px white fw-500 txt-left"
                  >담당자명</label
                >
                <input
                  class="input"
                  type="text"
                  v-model="inquiryData.manager"
                />
              </div>
              <div class="clear mt-15px input-box">
                <label class="form-input ft-22px white fw-500 txt-left"
                  >연락처</label
                >
                <input class="input" type="text" v-model="inquiryData.phone" />
              </div>
              <div class="clear mt-15px input-box">
                <label class="form-input ft-22px white fw-500 txt-left"
                  >이메일</label
                >
                <input class="input" type="text" v-model="inquiryData.email" />
              </div>
              <div class="clear mt-15px input-box funnel-wrapper">
                <label class="form-input ft-22px white fw-500 txt-left"
                  >유입경로</label
                >
                <ul class="funnel-list">
                  <li>
                    <input
                      type="radio"
                      name="path"
                      id="path1"
                      value="path1"
                      v-model="selectEnterPath"
                    />
                    <label for="path1" class="pointer">캐럿 담당자 미팅</label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="path"
                      id="path2"
                      value="path2"
                      v-model="selectEnterPath"
                    />
                    <label for="path2" class="pointer"
                      >캐럿 컨퍼런스 및 설명회 등 모임</label
                    >
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="path"
                      id="path3"
                      value="path3"
                      v-model="selectEnterPath"
                    />
                    <label for="path3" class="pointer"
                      >온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브,
                      블로그 등)</label
                    >
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="path"
                      id="path4"
                      value="path4"
                      v-model="selectEnterPath"
                    />
                    <label for="path4" class="pointer"> 인터넷 검색</label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="path"
                      id="path5"
                      value="path5"
                      v-model="selectEnterPath"
                    />
                    <label for="path5" class="pointer">
                      캐럿글로벌 종합안내서 책자 및 사보 등 자료</label
                    >
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="path"
                      id="path6"
                      value="path6"
                      v-model="selectEnterPath"
                    />
                    <label for="path6" class="pointer"
                      >타사 담당자 및 전임자 등 지인 소개</label
                    >
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="path"
                      id="path7"
                      value="path7"
                      v-model="selectEnterPath"
                    />
                    <label for="path7" class="pointer">기타</label>
                    <input
                      v-show="selectEnterPath === 'path7'"
                      type="text"
                      name="enterPathText"
                      id="enterPathText"
                      class="etc-input"
                      placeholder="직접 입력"
                      v-model="selectEnterPathText"
                    />
                  </li>
                </ul>
              </div>
            </form>
          </li>
          <li class="input-inquiry float-right fw-500 w-47per">
            <h3 class="title txt-left white ft-22px">문의사항</h3>
            <textarea
              class="inquiry-area mt-15px p-25px ft-16px w-100per"
              name="inquiry"
              id="inquiry"
              cols="30"
              rows="10"
              placeholder="전화·화상외국어과정 문의합니다."
              v-model="inquiryData.contents"
            ></textarea>
          </li>
          <li>
            <div class="checks float-right">
              <input
                class="pointer"
                type="checkbox"
                id="agree"
                v-model="inquiryData.agree"
              />
              <label class="privacy pointer" for="agree"
                >개인정보 수집 및 이용에 동의합니다.</label
              >
              <button class="confirm pointer" @click="saveInquiry()">
                확인
              </button>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
// import { mapMutations } from "vuex";
import Header from "@/components/Solutions/Header.vue";
import Footer from "@/components/Solutions/Footer.vue";
import LayerPopVideo from "@/components/Solutions/LayerPopVideo.vue";
export default {
  components: {
    Header,
    Footer,
    LayerPopVideo,
  },
  data() {
    return {
      inquiryData: {
        category: "INBOUND", //기타
        company: "", //고객사명
        manager: "", //담당자
        phone: "", //연락처
        email: "", //이메일
        contents: "", //내용
        agree: false,
        enterPath: "", //유입경로
        enterPathText: "", // 기타입력
        enterUrl: window.location.href, //사이트주소
      },
      selectEnterPath: "",
      selectEnterPathText: "",
      pathValue: [
        { key: "path1", value: "캐럿 담당자 미팅" },
        { key: "path2", value: "캐럿 컨퍼런스 및 설명회 등 모임" },
        {
          key: "path3",
          value:
            "온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브, 블로그 등)",
        },
        { key: "path4", value: "인터넷 검색" },
        { key: "path5", value: "캐럿글로벌 종합안내서 책자 및 사보 등 자료" },
        { key: "path6", value: "타사 담당자 및 전임자 등 지인 소개" },
        { key: "path7", value: "기타" },
      ],
      smile: "0.0", //오늘의 수업 만족도
      layerVisible: false,
    };
  },
  mounted() {
    /* js 표준 fetch */
    fetch(
      "https://www.carrotenglish.kr/rest_free/phone/report?page=1&category=이벤트"
    )
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        const { smile } = myJson;
        console.log("smile : ", smile);
        this.smile = smile;
      });
  },
  created() {
    // this.setCurrentPath(this.$router.currentRoute.path);
  },
  methods: {
    // ...mapMutations({
    //   setCurrentPath: "setCurrentPath",
    // }),
    newPage(path) {
      window.open(path, "_blank");
    },
    scrollId(id) {
      document.getElementById(id).scrollIntoView();
    },
    saveInquiry() {
      let flag = false;
      for (const key in this.inquiryData) {
        if (key === "company" && !this.inquiryData[key]) {
          alert("회사명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "manager" && !this.inquiryData[key]) {
          alert("담당자명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "phone" && !this.inquiryData[key]) {
          alert("연락처를 입력해주세요");
          flag = true;
          return;
        } else if (key === "email" && !this.inquiryData[key]) {
          alert("이메일을 입력해주세요");
          flag = true;
          return;
        } else if (key === "contents" && !this.inquiryData[key]) {
          alert("내용을 입력해주세요");
          flag = true;
          return;
        } else if (key === "agree" && !this.inquiryData[key]) {
          alert("개인정보 수집에 동의해주세요");
          flag = true;
          return;
        }
      }

      if (
        !this.inquiryData["enterPath"] &&
        !this.inquiryData["enterPathText"]
      ) {
        alert("유입경로를 선택 및 기타에 입력해주세요");
        flag = true;
        return false;
      }

      if (!flag) {
        const find = this.pathValue.find(
          (findItem) => findItem["key"] === this.inquiryData["enterPath"]
        );
        const pathText = find ? find["value"] : "";
        this.inquiryData["enterPath"] = pathText;

        this.axios
          .get("/rest/external/addSMP", {
            params: this.inquiryData,
          })
          .then((res) => {
            if (res.data.err === 0) {
              alert("문의가 완료되었습니다.");
              this.inquiryData = {
                category: "INBOUND",
                company: "", //고객사명
                manager: "", //담당자
                phone: "", //연락처
                email: "", //이메일
                contents: "", //내용
                agree: false,
                enterPath: "",
                enterPathText: "",
                enterUrl: window.location.href, //사이트주소
              };
              this.selectEnterPath = "";
              this.selectEnterPathText = "";
            } else {
              alert(res.data.err_msg);
            }
          })
          .catch((err) => {
            console.error("err : ", err);
            alert("문의하기에 실패하였습니다.");
          });
      }
    },
    close() {
      this.layerVisible = false;
    },
  },

  watch: {
    selectEnterPath: function (val) {
      if (val === "path7") {
        this.inquiryData.enterPath = "";
      } else {
        this.inquiryData.enterPath = val;
        this.inquiryData.enterPathText = "";
        this.selectEnterPathText = "";
      }
    },

    selectEnterPathText: function (val) {
      this.inquiryData.enterPathText = val;
    },
  },
};
</script>

<style lang="scss">
.top-img {
  padding-bottom: 0px;
  background-image: url("~@/assets/img/top_img1.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .sub-title {
    width: 570px;
    word-break: keep-all;
    font-size: 33px;
    line-height: 45px;
  }

  .download {
    /* 2022.03.07 kate님께서 제안서 다운로드 삭제를 요청하였으나, 추후 사용할일이 있을수 있으므로  display: none 처리 */
    display: none;
  }
}
.description {
  line-height: 33px !important;
}

/* 교육 문의하기 버튼 */
.inquiry {
  display: inline-block;
  width: 210px;
  height: 64px;
  border-radius: 32px;
  box-shadow: 0px 4px 9px 0 rgba(0, 0, 0, 0.1);
  background-color: #fe1d59;
  padding: 20px 46px;
}

/* 소개 영상보기 버튼 */
.introduce {
  display: inline-block;
  width: 210px;
  height: 64px;
  border-radius: 32px;
  box-shadow: 0px 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #fff;
  background-color: #383d49;
  padding: 20px 42px;
}

/*  통계 */
.statistics {
  width: 100%;
  height: 100%;
  margin-top: 89px;
  background: rgba(0, 0, 0, 0.6);

  .statistics-ml {
    margin-left: 240px;
  }

  .circle-box {
    display: inline-block;
    width: 63px;
    height: 63px;
    line-height: 63px;
    border-radius: 34px;
    background: rgba(255, 255, 255, 0.1);
    text-align: center;

    .icon {
      vertical-align: middle;
      box-shadow: 0.9px 2.9px 24px 0 rgba(0, 0, 0, 0.2);
    }
  }

  .count-title {
    font-size: 20px;
    line-height: 20px;
  }

  .count {
    font-size: 38px;
    line-height: 38px;
  }

  .statistic {
    padding: 35px 0;
  }
}

.zero {
  width: 50%;
  margin: 0 auto;
}

/* 1번째 section */
.first {
  background: #fff;
  .enviroment-img {
    width: 100%;
    height: 415px;
  }

  .enviroment-center {
    .enviroment {
      padding: 8% 0;
    }
  }
}

/* 2번재 section */
.second {
  background: #f9f7f7;
  .contents {
    padding: 10% 0;
  }
}

/* 3번째 section */
.third {
  background: #fff;

  .satisfaction {
    padding: 11% 0;
  }
}

/* 4번째 section */
.fourth {
  background: #f9f7f7;

  .card-ul {
    max-width: 1100px;
    margin: 0 auto;
  }

  .card {
    width: 30.9%;
    border-radius: 22px;
    background-color: #fff;
    box-shadow: 0.9px 2.9px 24px 0 rgba(0, 0, 0, 0.07);

    .arrow-img {
      vertical-align: 2px;
      margin-left: 10px;
      width: 6px;
      height: 11px;
    }

    .card-img {
      display: block;
      width: 100%;
    }

    .card-circle {
      display: inline-block;
      width: 39px;
      height: 40px;
      line-height: 40px;
      border-radius: 19.5px;
      text-align: center;

      &.pink {
        background-image: linear-gradient(to top, #fe1d59, #fc4873);
      }

      &.blue {
        background-image: linear-gradient(to top, #1d97ca, #1d5aca);
      }

      .icon {
        vertical-align: middle;
      }
    }

    .text {
      .pink {
        color: #fe1d59;
      }
      .blue {
        color: #1d5aca;
      }
    }
  }

  .process {
    border-radius: 22px;
    background-color: #293243;
    padding: 2.688em 1.75em;
    box-shadow: 0.9px 2.9px 24px 0 rgba(0, 0, 0, 0.07);

    .arrow-img {
      vertical-align: 2px;
      margin-left: 10px;
      width: 6px;
      height: 11px;
    }

    .process-list {
      text-align: center;
      .list-box {
        margin: 0 auto;
        padding-right: 70px;
      }
    }
    .circle {
      padding: 0.6em 1.2em;
      border-radius: 34.5px;
      font-size: 1.375rem;
      border: solid 1px #fff;
      background-color: #293243;
      margin: 0 auto;
    }

    .circle-box {
      display: inline-block;
      width: 39px;
      height: 40px;
      line-height: 40px;
      border-radius: 19.5px;
      text-align: center;

      &.pink {
        background-image: linear-gradient(to top, #fe1d59, #fc4873);
      }

      .icon {
        max-width: 100%;
        max-height: 100%;
        vertical-align: 4px;
      }
    }
  }
}

/* 5번째 section */
.five {
  background: #fff;

  .card {
    width: 32%;

    .rank-title {
      color: #293243 !important;
    }

    .circle {
      border-radius: 40px;
      padding: 12px 24px !important;

      &.blue {
        background-color: rgba(29, 90, 202, 0.16);
        color: #2a3b5b;
      }

      &.pink {
        background-color: rgba(254, 29, 89, 0.16);
        color: #fe1d59 !important;
      }
    }
  }

  .language {
    border-radius: 22px;
    box-shadow: 0.9px 2.9px 24px 0 rgba(0, 0, 0, 0.07);
    background-color: #fff;

    .languages-list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 25px;

      @media screen and (min-width: 768px) {
        grid-template-columns: repeat(8, 1fr);
        gap: 10px;
      }
      // display: flex;
      // justify-content: space-between;

      .item {
        // flex-basis: 10%;

        .country-images {
          filter: drop-shadow(0.9px 2.9px 13px rgba(0, 0, 0, 0.17));
        }
      }

      &:nth-child(2) {
        margin-top: 30px;
      }
    }
  }
}

/* 6 번째 section */
.six {
  width: 100%;
  background: url("~@/assets/img/introuducd_img.png");
  background-repeat: no-repeat;
  background-size: cover;
}

/* 7 번째 section */
.seven {
  background: #fff;

  .m-country {
    display: none;
  }

  .country {
    display: block;
    width: 100%;
    height: auto;
  }
}

/* 8 번째 section */
.eight {
  background: #181818;

  .input-box {
    display: flex;
    align-items: center;
    gap: 0 20px;
  }

  .funnel-wrapper {
    .funnel-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      li {
        display: flex;
        align-items: center;
        gap: 10px;

        label {
          color: #ffffff;
        }

        .etc-input {
          height: 100%;
          font-size: 13px;
          border-radius: 8px;
          border: solid 1px #626264 !important;
          background-color: #181818 !important;
        }

        &:last-child {
          width: 100%;
        }
      }
    }
  }

  .form-input {
    display: inline-block;
    text-align: right;
    width: 80px;
    flex: none;
  }

  .input {
    width: 70%;
    font-size: 22px;
    height: 47px;
    border-radius: 8px;
    border: solid 1px #626264 !important;
    background-color: #181818 !important;
  }

  .inquiry-area {
    width: 450px;
    height: 307px;
    resize: none;
    border-radius: 8px;
    border: solid 1px #626264;
    background-color: #181818;
  }

  .checks {
    position: relative;
    margin-top: 19px;

    input[id="ex_chk"] + label {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: solid 1px #626264;
      cursor: pointer;
      margin-top: -6px;
    }

    input[id="ex_chk"]:checked + label {
      background-color: #666666;
    }
    input[id="ex_chk"] {
      display: none;
    }

    .privacy {
      font-size: 18px !important;
      margin-left: 10px;
      color: #626264;
      vertical-align: -2px;
    }

    .confirm {
      background-color: #464646;
      border-radius: 8px;
      border: 0;
      outline: 0;
      padding: 9px 19px;
      font-size: 18px;
      font-weight: 500;
      margin-left: 13px;
      color: #fff;
    }
  }
}

/* 767px 이하 */
@media only screen and (max-width: 767px) {
  .top-img {
    background-image: url("~@/assets/img/m-top-img.png");
    .title {
      font-size: 40px;
      margin-top: 100px !important;
      text-align: center;
    }

    .m-btn-group {
      text-align: center;
    }

    .sub-title {
      font-size: 20px;
      text-align: center;
      width: 100%;
      padding: 0px 81px;
      line-height: 32px !important;
    }

    .download {
      font-size: 18px !important;
      text-align: center;
    }

    .inquiry {
      width: 153px;
      height: 47px;
      padding: 13px 28px;
      margin-top: 51px !important;

      .title {
        font-size: 16px !important;
      }
    }

    .introduce {
      width: 153px;
      height: 47px;
      padding: 12px 24px;
      margin-left: 14px !important;

      .title {
        font-size: 16px !important;
      }
    }

    .statistics {
      padding: 21px 24px !important;

      .text {
        margin-left: 0px !important;
      }

      .count-title {
        text-align: center !important;
        font-size: 14px !important;
        margin-top: 13px !important;
      }

      .count {
        font-size: 18px !important;
        line-height: 20px !important;
        text-align: center !important;
        margin-top: 0px !important;
      }

      .circle-box {
        width: 44px !important;
        height: 44px !important;
      }

      .icon-parent {
        width: 100%;
        .person-icon {
          width: 15px;
          vertical-align: 5px;
        }

        .heart-icon {
          width: 20px;
          vertical-align: 5px;
        }

        .messages-icon {
          width: 20px;
          vertical-align: 5px;
        }
      }

      .m-statistics {
        display: block !important;
        text-align: center;
      }
    }
  }

  .first {
    padding: 0 !important;
    .m-first {
      max-width: 414px !important;
      width: 100% !important;
      padding: 40px 22px !important;

      .first-title {
        font-size: 27px !important;
        line-height: 32px !important;
        word-break: keep-all;
      }

      .second-title {
        font-size: 27px !important;
        line-height: 32px !important;
        word-break: keep-all;
      }

      .enviroment-center {
        margin-top: 32px !important;
      }

      .enviroment {
        float: none !important;
        margin-top: 0px !important;
        width: 100% !important;
        padding: 0 !important;
      }

      .enviroment-title {
        width: 100% !important;
        word-break: keep-all;
        padding: 0 70px !important;
        font-size: 24px !important;
        line-height: 30px !important;
        text-align: center !important;
      }

      .enviroment-desc {
        width: 100% !important;
        word-break: keep-all;
        font-size: 17px !important;
        line-height: 25px !important;
        text-align: center !important;
      }

      .enviroment2 {
        float: none !important;
        width: 75% !important;
        margin: 0 auto;
        margin-top: 29px !important;

        .enviroment2-img {
          width: 100% !important;
        }
      }
    }
  }

  .second {
    padding: 0 !important;
    .m-second {
      max-width: 414px !important;
      width: 100% !important;
      padding: 40px 22px !important;

      .reverse {
        transform: rotate(180deg);

        .reverse-child {
          transform: rotate(-180deg);
        }
      }

      .contents-img {
        float: none !important;
        width: 75% !important;
        margin: 0 auto;
        line-height: normal !important;

        .contents-image {
          width: 100%;
          height: auto;
        }
      }

      .contents {
        float: none !important;
        width: 100% !important;
        margin-top: 42px !important;
        padding: 0 !important;

        .contents-title {
          font-size: 24px !important;
          line-height: 30px !important;
          text-align: center !important;
        }

        .contents-desc {
          word-break: keep-all;
          font-size: 18px !important;
          line-height: 25px !important;
          text-align: center !important;
          margin-top: 15px !important;
        }
      }
    }
  }

  .third {
    padding: 0 !important;
    .m-third {
      max-width: 414px !important;
      width: 100% !important;
      padding: 40px 22px !important;

      .satisfaction {
        float: none !important;
        width: 100% !important;
        margin-top: 0px !important;
        padding: 0 !important;

        .satisfaction-title {
          font-size: 24px !important;
          line-height: 30px !important;
          text-align: center !important;
        }

        .satisfaction-desc {
          font-size: 18px !important;
          line-height: 25px !important;
          margin-top: 15px !important;
          text-align: center !important;
        }
      }

      .satisfaction-image {
        float: none;
        margin-top: 34px !important;
        width: 75% !important;
        margin: 0 auto;

        .satisfaction-img {
          width: 100% !important;
        }
      }
    }
  }

  .fourth {
    padding: 0 !important;
    .m-fourth {
      max-width: 414px !important;
      width: 100% !important;
      padding: 40px 22px !important;

      .course-title {
        font-size: 27px !important;
        line-height: 32px !important;
        padding: 0 35px !important;
        text-align: center !important;
      }

      .course-title2 {
        font-size: 27px !important;
        line-height: 32px !important;
        margin-top: 0px !important;
      }

      .card-list {
        margin-top: 40px !important;
        .card {
          float: none;
          width: 100% !important;
          margin-left: 0px !important;

          &:nth-child(2) {
            margin-top: 24px !important;
          }

          &:nth-child(3) {
            margin-top: 24px !important;
          }

          .text {
            .detail {
              line-height: 1 !important;
            }
          }

          .card-circle {
            .icon {
              display: inline-block;
              line-height: 40px;
              position: relative;
            }
          }
        }
      }

      .process {
        padding: 45px 26px;
        .process-list {
          .list-box {
            padding-right: 0 !important ;
          }
        }
        .list {
          margin-left: 0px;

          &:nth-child(2) {
            margin-left: 3% !important;
          }

          &:nth-child(3) {
            margin-top: 1.2rem !important;
          }
          &:nth-child(4) {
            margin-top: 1.2rem !important;
            margin-left: 3%;
          }
          &:nth-child(5) {
            margin-top: 1.2rem !important;
          }
        }

        .circle {
          line-height: 1;
          padding: 0.5em 1.1em;
          font-size: 1.2rem;
        }

        .other {
          float: left;
          margin-left: 0.1em;
        }

        .circle-box {
          .icon {
            display: inline-block;
            line-height: 40px;
            position: relative;
          }
        }
      }
    }
  }

  .five {
    padding: 0 !important;
    .m-five {
      max-width: 414px !important;
      width: 100% !important;
      padding: 40px 22px !important;

      .performance-title {
        font-size: 27px !important;
        line-height: 32px !important;
        padding: 0 33px !important;
      }

      .special-title {
        font-size: 21px !important;
        margin: 10px 0 0 0;
        line-height: 1 !important;
      }

      .rank {
        margin-top: 35px !important;
        padding: 0 !important;

        .rank-title {
          margin-top: 14px !important;
          .rank-title1 {
            font-size: 21px !important;
            display: inline !important;
          }
          .rank-title2 {
            font-size: 21px !important;
            display: inline !important;
          }
        }
      }
    }

    .card {
      float: none;
      width: 100% !important;

      &:nth-child(2) {
        margin-top: 28px !important;
      }

      &:nth-child(3) {
        margin-top: 28px !important;
      }

      .circle {
        padding: 6px 15px !important;
        font-size: 20px !important;
      }
    }

    .language {
      padding: 27px !important;
      margin-top: 34px !important;
      .languages-list {
        // flex-wrap: wrap;
        // gap: 0 5%;

        &:nth-child(2) {
          margin-top: 30px !important;
        }
        .item {
          flex-basis: 21%;

          .txt-center {
            .img-parent {
              display: inline-block;
              width: 86% !important;
            }

            .country-images {
              display: block;
              width: 100%;
            }

            .country-name {
              margin-top: 9px !important;
              font-size: 12px !important;
              line-height: 1 !important;
            }
          }
        }

        .item:nth-child(n + 5) {
          // margin-top: 28px;
        }
      }
    }
  }

  .six {
    padding: 0 !important;
    .m-six {
      max-width: 414px !important;
      width: 100% !important;
      padding: 22px !important;

      .title {
        font-size: 27px !important;
        line-height: 34px !important;
        letter-spacing: -0.14px;
      }

      .title2 {
        font-size: 27px !important;
        line-height: 32px !important;
        word-break: keep-all;
        padding: 0 4.063rem;
        margin-top: 0px !important;
      }

      .title3 {
        font-size: 16px !important;
        margin-top: 20px !important;
      }
    }
  }

  .seven {
    padding: 0 !important;
    .m-seven {
      max-width: 414px !important;
      width: 100% !important;
      padding: 40px 22px !important;

      .country {
        display: none;
      }

      .m-country {
        display: block;
        width: 100% !important;
      }

      .parent-company-image {
        width: 100% !important;
      }
    }
  }

  .eight {
    padding: 0 !important;
    .m-eight {
      max-width: 414px !important;
      width: 100% !important;
      padding: 22px !important;

      .input-box {
        margin-top: 6px !important;
      }

      .title {
        font-size: 27px !important;
      }

      .sub-title {
        font-size: 16px !important;
        line-height: 21px !important;
        margin-top: 15px !important;
      }

      .sub-title2 {
        font-size: 14px !important;
        line-height: 21px !important;
        margin-top: 11px !important;
      }

      .input-info {
        float: none;
        width: 100% !important;

        .form-input {
          float: left !important;
          font-size: 14px !important;
        }

        .input {
          width: 100%;
          height: 30px;
          float: right !important;
          margin-left: 0px !important;
        }
      }

      .input-inquiry {
        float: none;
        width: 100% !important;
        margin-top: 17px !important;

        .title {
          font-size: 14px !important;
        }

        .inquiry-area {
          font-size: 14px !important;
          height: 102px;
        }
      }

      .checks {
        // float: right;
        margin-top: 17px;

        input[id="ex_chk"] + label {
          width: 10px;
          height: 10px;
          border-radius: 2px;
          margin-top: 8px;
        }

        .privacy {
          font-size: 14px !important;
          margin-left: 5px;
          color: #626264;
          vertical-align: -1px;
        }

        .confirm {
          background-color: #626062;
          border-radius: 8px;
          border: 0;
          outline: 0;
          padding: 7px 11px;
          font-size: 14px;
          font-weight: 500;
          margin-left: 13px;
          color: #fff;
        }
      }
    }
  }

  .line-break {
    display: none;
  }
}

/* 413px 이하 */
@media only screen and (max-width: 413px) {
  .m-fourth {
    .process {
      .circle {
        font-size: 18px !important;
      }
    }

    .list {
      &:nth-child(2) {
        margin-left: 1% !important;
      }
      &:nth-child(3) {
        margin-right: 10px !important;
      }
      &:nth-child(4) {
        margin-left: 0px !important;
      }
      &:nth-child(5) {
        margin-top: 1.2rem !important;
        margin-left: 1% !important;
      }
    }
  }
}
</style>
